import { useState } from 'react';
import { Box, Typography, Tabs, Tab } from '@mui/material';
import SimpleCalculator from './SimpleCalculator';
import IntelligentCalculator from './IntelligentCalculator';

export default function PriceCalculatorPage() {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <Box>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
        <Typography variant="h5">Prisberegner</Typography>
      </Box>

      <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
        <Tabs value={activeTab} onChange={(_, v) => setActiveTab(v)}>
          <Tab label="Simpel beregner" />
          <Tab label="Intelligent beregner" />
        </Tabs>
      </Box>

      {activeTab === 0 && <SimpleCalculator />}
      {activeTab === 1 && <IntelligentCalculator />}
    </Box>
  );
}
